<img [appPlannerIndicator]="assignment.status" (click)="clickCell($event)" />
